/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from "../../Styles/dashboard.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { urlEnum } from "../../Utils/UrlEnum";
import MainTable from "../../Components/GenericComponents/MainTable";
import React, { useContext, useEffect, useState } from "react";
import {
  FiltersModel,
  ImportExcelDescription,
  ProductModel,
} from "../../Utils/Models";
import { postData } from "../../Services/postData";
import ProductMainPage from "../../Components/Products/ProductMainPage";
import {
  Button,
  Chip,
  useMediaQuery,
  IconButton,
  Tooltip,
} from "@mui/material";
import { CacheWebsocketContext } from "../../Contexts/WebsocketContext";
import { dayPilotFormat, euFormatForDateTime } from "../../Utils/Config";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Filters from "../../Components/Reports/Filters";
import ImportExcelButton from "../../Components/GenericComponents/ImportExcelButton";
import ImportExcelModal from "../../Components/GenericComponents/ImportExcelModal";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import SyncIcon from "@mui/icons-material/Sync";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getData } from "../../Services/getData";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { updateData } from "../../Services/updateData";
import SyncWordPressData from "../../Components/SyncWordPressData";

type OpenModal = {
  action: string | null;
  value: boolean;
};

export default function Products() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const websocketContext = useContext(CacheWebsocketContext);
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [openModal, setOpenModal] = useState<OpenModal>({
    action: null,
    value: false,
  });
  const [editItem, setEditItem] = useState<ProductModel | null>(null);
  const [shouldUpdate, setShouldUpdate] = useState(0);
  const [selectedIds, setSelectedIds] = useState<Array<string>>([]);
  const productsDataRef = React.useRef<Array<any>>([]);
  const [filters, setFilters] = useState<FiltersModel>({
    startDate: moment().startOf("year"),
    endDate: moment().endOf("month"),
    type: null,
    category: null,
    inventory: null,
    manufacturer: null,
    tags: null,
  });
  const [syncWp, setSyncWp] = useState(false);

  /**
   *
   */
  const description: Array<ImportExcelDescription> = [
    {
      name: "Name",
      description: Vocabulary.itemName,
      example: "TerraE INR18650 35E3 3.6V 3350mAh 11.70Wh LiMnO2",
    },
    {
      name: "Code",
      description: Vocabulary.itemCode,
      example: "41030012",
    },
    {
      name: "Description",
      description: Vocabulary.itemDescription,
      example: "High-capacity rechargeable lithium-ion battery.",
    },

    {
      name: "EAN",
      description: Vocabulary.itemPartNumber,
      example: "TEST",
    },
    {
      name: "Type",
      description: Vocabulary.itemType,
      example: "Product",
    },
    {
      name: "Category ",
      description: Vocabulary.itemCategory,
      example: "Zellen Neu",
    },
    {
      name: "Manufacturer",
      description: Vocabulary.itemManufacturer,
      example: "Bmz",
    },
    {
      name: "Price",
      description: Vocabulary.itemSellingPrice,
      example: "4.81",
    },
    {
      name: "VAT",
      description: Vocabulary.itemSellingVAT,
      example: "8.10",
    },
    {
      name: "Purchase price",
      description: Vocabulary.itemPurchaseStockPrice,
      example: "2.59",
    },
    {
      name: "Tags",
      description: Vocabulary.itemTags,
      example: "Battery, Lithium-ion, Rechargeable",
    },
  ];

  /**
   * Toggle WordPress sync for a product
   */
  const toggleWordPressSync = async (
    rowIndex: number,
    currentValue: boolean
  ) => {
    try {
      const product = productsDataRef.current[rowIndex];
      if (!product || !product._id) {
        toast.error(Vocabulary.productNotFound);
        return;
      }

      const newValue = !currentValue;
      const response = await updateData(
        `${urlEnum.products}/${product._id}/wordpress-sync`,
        { syncToWordPress: newValue }
      );

      if (response?.data?.success) {
        setShouldUpdate((prev) => prev + 1);
      } else {
        toast.error(Vocabulary.filedToUpdateWordpress);
      }
    } catch (error) {
      console.error(Vocabulary.filedToUpdateWordpress, error);
      toast.error(Vocabulary.filedToUpdateWordpress);
    }
  };

  /**
   *
   */
  const productsHeader = [
    {
      label: Vocabulary.name,
      name: "name",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <>{value.length > 15 ? `${value.substring(0, 15)}...` : value}</>
          );
        },
      },
    },
    {
      label: Vocabulary.code,
      name: "code",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <>{value.length > 15 ? `${value.substring(0, 15)}...` : value}</>
          );
        },
      },
    },
    {
      label: Vocabulary.typeString,
      name: "type",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.categoryString,
      name: "category",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.manufacturer,
      name: "manufacturer",
      options: {
        sort: true,
        display: "false",
      },
    },
    {
      label: `${Vocabulary.inventories}`,
      name: "inventories",
      options: {
        sort: false,
        customBodyRender: (values: any) => {
          return (
            <>
              {values
                ? values.map((value: any) => {
                    if (value.inventory?.name)
                      return (
                        <Chip
                          key={value._id}
                          label={value.inventory?.name}
                          style={{ marginRight: 5, marginBottom: 5 }}
                        />
                      );
                    return null;
                  })
                : null}
            </>
          );
        },
      },
    },
    {
      label: Vocabulary.quantity,
      name: "inventories",
      options: {
        sort: false,
        display: "false",
        customBodyRender: (values: any) => {
          return (
            <>
              {values
                ? values.reduce((acc: number, value: any) => {
                    return acc + +value.quantity;
                  }, 0)
                : null}
            </>
          );
        },
      },
    },
    {
      label: Vocabulary.vat,
      name: "vat",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.stockPrice,
      name: "price",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.tags,
      name: "tags",
      options: {
        sort: true,
        display: "false",
        customBodyRender: (values: any) => {
          return (
            <>
              {values &&
                values.map((value: string, index: number) => (
                  <>
                    {index < 3 ? (
                      <Chip
                        key={value}
                        label={value}
                        style={{ marginRight: 5, marginBottom: 5 }}
                      />
                    ) : index === 3 ? (
                      <Chip
                        key={value}
                        label={"..."}
                        style={{ marginRight: 5, marginBottom: 5 }}
                      />
                    ) : null}
                  </>
                ))}
            </>
          );
        },
      },
    },
    {
      label: Vocabulary.createdAt,
      name: "createdAt",
      options: {
        sort: false,
        customBodyRender: (value: any, meta: any) => {
          return <>{value ? moment(value).format(euFormatForDateTime) : ""}</>;
        },
      },
    },
    {
      label: Vocabulary.syncToWordPress,
      name: "syncToWordPress",
      options: {
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const syncEnabled = value !== undefined ? value : true;
          return (
            <Tooltip title={Vocabulary.toggleWordPressSync}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleWordPressSync(tableMeta.rowIndex, syncEnabled);
                }}
                style={{
                  color: syncEnabled ? "#4caf50" : "#9e9e9e",
                }}
              >
                {syncEnabled ? <SyncIcon /> : <SyncDisabledIcon />}
              </IconButton>
            </Tooltip>
          );
        },
      },
    },
  ];

  /**
   *
   */
  useEffect(() => {
    const search = location.search.split(/[?&]+/);
    const newFilters: any = {
      startDate: moment().startOf("year"),
      endDate: moment().endOf("month"),
      type: null,
      category: null,
      inventory: null,
      manufacturer: null,
      tags: null,
    };
    search.forEach((value: any) => {
      if (value !== "") {
        const values = value.split("=");
        newFilters[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });
    setFilters({
      ...newFilters,
      startDate: moment(newFilters.startDate, dayPilotFormat),
      endDate: moment(newFilters.endDate, dayPilotFormat),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  /**
   *
   * @param item
   */
  function handleEdit(item: ProductModel | null) {
    setOpen(!open);
    setEditItem(item);
  }
  /**
   *
   * @param step
   */
  function addOrUpdateProduct(product: ProductModel) {
    product.inventories.forEach((inv: any) => {
      delete inv.isNew;
    });
    //form data
    const formData: any = new FormData();
    if (product.files && product.files.length !== 0)
      product.files.forEach((file: any) => {
        formData.append("files", file, file.name);
      });
    else formData.append("files", []);
    product.images = product.images.filter(
      (img: any) => typeof img === "string"
    );
    product.files = [];
    product.variants.forEach((variant: any) => {
      variant.images = !variant.images
        ? []
        : variant.images.map((img: any) => {
            return typeof img === "string"
              ? img
              : {
                  name: img.name,
                  path: "",
                };
          });
    });
    formData.append("product", JSON.stringify(product));
    //end form data

    if (product?._id) {
      postData(`${urlEnum.products}/${product._id}`, formData)
        .then((res) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setOpen(false);
            setShouldUpdate((prev) => prev + 1);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    } else {
      postData(urlEnum.products, formData)
        .then((res: any) => {
          if (res) {
            websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
            setOpen(false);
            setShouldUpdate((prev) => prev + 1);
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    }
  }

  /**
   *
   * @param data
   */
  const syncWordPressData = () => {
    try {
      const url = `${urlEnum.syncWordPressDataProducts}`;
      getData(url).then((res: AxiosResponse) => {
        if (res.data) {
          setShouldUpdate((prev) => prev + 1);
          toast.success(`${res.data.message}`);
        }
      });
    } catch (e) {
      toast.error(`${e}`);
    }
  };

  /**
   *
   * @param items
   */
  async function saveToDatabase(items: any) {
    const res = await postData(`${urlEnum.products}/insertMany`, items);
    if (res && res.data && res.data.result) {
      setOpenImportExcel(false);
      setShouldUpdate((prev) => prev + 1);
    }
  }

  /**
   * Duplicate a product
   * @param product
   */
  async function handleDuplicate(product: ProductModel) {
    try {
      // Create a copy of the product without the _id
      const duplicatedProduct = {
        ...product,
        _id: undefined,
        name: `${product.name} (Copy)`,
        code: `${product.code || ""}-COPY`,
        ean: `${product.ean || ""}-COPY`,
        inventories: product.inventories.map((inv: any) => ({
          ...inv,
          _id: undefined,
          isNew: true,
        })),
        variants: product.variants.map((variant: any) => ({
          ...variant,
          _id: undefined,
        })),
      };

      // Create FormData for the duplicated product
      const formData: any = new FormData();
      formData.append("files", []);

      // Filter images and prepare product data
      duplicatedProduct.images = duplicatedProduct.images.filter(
        (img: any) => typeof img === "string"
      );
      duplicatedProduct.files = [];

      formData.append("product", JSON.stringify(duplicatedProduct));

      const res = await postData(urlEnum.products, formData);
      if (res && res.data && res.data.result) {
        toast.success(Vocabulary.duplicateSuccess || "Product duplicated successfully");
        websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
        setShouldUpdate((prev) => prev + 1);
      }
    } catch (error) {
      toast.error(`Failed to duplicate product: ${error}`);
    }
  }
  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <Filters
        filters={filters}
        recalculateReportsButton={false}
        type={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        category={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        inventory={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        manufacturer={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        tags={{
          show: true,
          multiple: true,
          disableClearable: false,
        }}
      />
      <MainTable
        urlEnumApi={urlEnum.products}
        header={productsHeader}
        tableTitle={Vocabulary.productsList}
        deleteMessages={{
          title: Vocabulary.deleteProduct,
          text: Vocabulary.deleteConfirmationProduct,
        }}
        shouldUpdate={shouldUpdate}
        handleEdit={handleEdit}
        anotherOptionButtons={[
          {
            condition: () => true,
            title: Vocabulary.duplicate || "Duplicate",
            icon: <ContentCopyIcon fontSize="small" />,
            action: (product: ProductModel) => handleDuplicate(product),
          },
        ]}
        onTableDataChange={(items) => {
          productsDataRef.current = items;
        }}
        customStyle={{
          colorForRaw: (value: any) => {
            if (value.alert) return value.alert.alert.color || "white";
            return "white";
          },
        }}
        headerButtons={
          <>
            <Button
              onClick={() => {
                setSyncWp(true);
              }}
            >
              <CloudSyncIcon color="primary" />
              <p style={{ fontSize: "12px", color: "rgb(63, 81, 181)" }}>
                {Vocabulary.wordpressSync}
              </p>
            </Button>
            <ImportExcelButton
              onClickImportButton={() => {
                setOpenImportExcel(true);
              }}
            />
          </>
        }
      />
      {open ? (
        <ProductMainPage
          editProduct={editItem}
          open={open}
          addOrUpdateProduct={(product) => addOrUpdateProduct(product)}
          onClose={() => handleEdit(null)}
        />
      ) : null}
      {openImportExcel ? (
        <ImportExcelModal
          open={openImportExcel}
          onClose={() => setOpenImportExcel(false)}
          saveItems={(items: any) => saveToDatabase(items)}
          description={description}
        />
      ) : null}

      {syncWp && (
        <SyncWordPressData
          wpUrl={urlEnum.syncWordPressDataProducts}
          open={syncWp}
          onClose={() => {
            setSyncWp(false);
          }}
          onSuccess={() => {
            setShouldUpdate((prev) => prev + 1);
          }}
        />
      )}
    </div>
  );
}
